import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import toast from 'react-hot-toast';

export default function CheckoutReturn() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');

  useEffect(() => {
    if (status === 'success') {
      toast.success('Payment completed successfully!');
    } else if (status === 'cancelled') {
      toast.error('Payment was cancelled');
    }
  }, [status]);

  const handleContinue = () => {
    navigate('/dashboard');
  };

  const handleRetry = () => {
    navigate('/subscriptions');
  };

  const isSuccess = status === 'success';

  return (
    <SoftBox
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      p={3}
    >
      <SoftBox mb={3}>
        {isSuccess ? (
          <CheckCircleIcon 
            sx={{ 
              fontSize: 80, 
              color: 'success.main' 
            }} 
          />
        ) : (
          <CancelIcon 
            sx={{ 
              fontSize: 80, 
              color: 'error.main' 
            }} 
          />
        )}
      </SoftBox>
      
      <SoftTypography 
        variant="h3" 
        fontWeight="bold" 
        color={isSuccess ? "success" : "error"} 
        textAlign="center"
        mb={2}
      >
        {isSuccess ? 'Payment Successful!' : 'Payment Cancelled'}
      </SoftTypography>
      
      <SoftTypography 
        variant="body1" 
        color="text" 
        textAlign="center"
        mb={4}
        maxWidth="500px"
      >
        {isSuccess 
          ? 'Your subscription has been activated successfully. You can now access all premium features.'
          : 'Your payment was cancelled. No charges have been made to your account. You can try again anytime.'
        }
      </SoftTypography>
      
      <SoftBox display="flex" gap={2}>
        {isSuccess ? (
          <SoftButton
            variant="gradient"
            color="success"
            size="large"
            onClick={handleContinue}
          >
            Continue to Dashboard
          </SoftButton>
        ) : (
          <>
            <SoftButton
              variant="gradient"
              color="error"
              size="large"
              onClick={handleRetry}
            >
              Try Again
            </SoftButton>
            
            <SoftButton
              variant="outlined"
              color="dark"
              size="large"
              onClick={handleContinue}
            >
              Go to Dashboard
            </SoftButton>
          </>
        )}
      </SoftBox>
    </SoftBox>
  );
}
